import React from 'react';
import TaskStatsSection from "./TaskStatsSection/TaskStatsSection";
import TransferStatsSection from "./TransferStatsSection/TransferStatsSection";
import UserStatsCard from "./UserStatsCard/UserStatsCard";
import TaskDetailsTable from "./TaskDetailsTable/TaskDetailsTable";

const Dashboard = (props) => {
    const { tasksAn, tasksRes, tasksSin, tasksResReassign, tasksAnReassign, tasksSinReassign } = props;

    return (
        <>
            {/* Section AN */}
            <TaskStatsSection
                title="Tâche AN de l'équipe"
                tasks={tasksAn}
                documentsTitle="Documents AN traités aujourd'hui"
            />
            <TransferStatsSection
                title="Statistiques du jour des transferts de tâches AN"
                tasks={tasksAn}
                reassignCount={tasksAnReassign}
                prefix="AN"
            />

            {/* Section RES */}
            <TaskStatsSection
                title="Tâche RES de l'équipe"
                tasks={tasksRes}
                documentsTitle="Documents RES traités aujourd'hui"
            />
            <TransferStatsSection
                title="Statistiques du jour des transferts de tâches RES"
                tasks={tasksRes}
                reassignCount={tasksResReassign}
                prefix="RES"
            />

            {/* Section SIN */}
            <TaskStatsSection
                title="Tâche SIN de l'équipe"
                tasks={tasksSin}
                documentsTitle="Documents SIN traités aujourd'hui"
            />
            <TransferStatsSection
                title="Statistiques du jour des transferts de tâches SIN"
                tasks={tasksSin}
                reassignCount={tasksSinReassign}
                prefix="SIN"
            />

            <div className={'row'}>
                <UserStatsCard
                    title="Nombre de tâches AN traitées par l'équipe aujourd'hui"
                    tasks={tasksAn}
                    colClass="col-4 ps-0"
                />
                <UserStatsCard
                    title="Nombre de tâches RES traitées par l'équipe aujourd'hui"
                    tasks={tasksRes}
                    colClass="col-4"
                />
                <UserStatsCard
                    title="Nombre de tâches SIN traitées par l'équipe aujourd'hui"
                    tasks={tasksSin}
                    colClass="col-4 pe-0"
                />
            </div>

            <div className={'row mb-5'}>
                <TaskDetailsTable
                    title="Détail des tâches AN en attente de traitement"
                    tasks={tasksAn}
                    colClass="col-4 ps-0"
                />
                <TaskDetailsTable
                    title="Détail des tâches RES en attente de traitement"
                    tasks={tasksRes}
                    colClass="col-4"
                />
                <TaskDetailsTable
                    title="Détail des tâches SIN en attente de traitement"
                    tasks={tasksSin}
                    colClass="col-4 pe-0"
                />
            </div>
        </>
    );
};

export default Dashboard;
